let Chart = class {
  renderChart (event, path) {
    if (event !== undefined) {
      // Make all children inactive
      let allChildren = Array.from(event.target.parentElement.children);
      allChildren.forEach((child, index) => {
        child.classList.remove('active');
      });

      // Make active
      event.target.classList.add('active');

    }
    //        document.querySelector("#revenue_chart_title").innerHTML = ''; //thomas edit, removed loading... but still need to clear out inner HTML or else charts stack on change
    $('.chart_loady').show(); //thomas edit
    let params = window.location.search.replace('?', '');

    $.getJSON('/charts' + path + '&' + params, (data) => {
      var selector = '#revenue_chart_title';
      console.log(data);
      if (data.chart.type === 'donut') {
        if (data.chartType === 'format') {
          selector = '#revenue_piechart_format';
        } else if (data.chartType === 'platform') {
          selector = '#revenue_piechart_platform';
        } else if (data.chartType === 'grouped') {
          selector = '#revenue_piechart_source';
        } else if (data.chartType === 'revToggled') {
          selector = '#rev-renderer-toggle';
        } else {
          selector = '#revenue_piechart_title';
        }

        if (data.chartType) {
          if (data.dataLabels) {
            //                        data.dataLabels.formatter = this.pieMoneyFormatter;
            if (data.chartType === 'revToggled') {
              //                            if( $('.money-label-switcher .ct.active').text() == 'Names' ){
              //                               data.dataLabels.formatter = this.pieIncludeTitle;
              //                            }else{
              //                               data.dataLabels.formatter = this.pieMoneyFormatter;
              //                            }

              data.dataLabels.formatter = this.pieIncludeTitle;

              data.legend.formatter = this.legendFormatter;

            } else {
              data.dataLabels.formatter = this.pieMoneyFormatter;
            }

          }
          if (data.tooltip.y) {
            data.tooltip.y.formatter = this.moneyFormatter;
          }
          if (data.tooltip.y.title) {
            data.tooltip.y.title.formatter = this.pieUpdateTitle;
          }
        } else {
          if (data.dataLabels) {
            data.dataLabels.formatter = this.pieFormatFormatter;
          }
        }
      } else {
        if (data.yaxis.labels) {
          // format yaxis as $$
          data.yaxis.labels.formatter = this.moneyFormatter;
        }
      }

      $(selector).html('');
      $(selector).empty();
      document.querySelector(selector).innerHTML = ''; //thomas edit, removed loading... but still need to clear out inner HTML or else charts stack on change
      var chart = new ApexCharts(document.querySelector(selector), data);
      chart.render();

      var legendHeight = $('#rev-renderer-toggle').find('.apexcharts-legend').innerHeight();
      $(document).find('.chart_display_container').css('padding-bottom', legendHeight);
      $(document).find('.chart_display_container .apexcharts-legend').css('inset', 'auto 0px -' + legendHeight + 'px');

      setTimeout(function() {
        window.dispatchEvent(new Event('resize'));

        if (data.chartType === 'revToggled') {
          setTimeout(function() {
            $(document).find('.chart_display_container .apexcharts-legend').css('inset', 'auto 0px -' + legendHeight + 'px');

            $('.chart_loady').fadeOut(250);
          }, 500);

        } else {
          $('.chart_loady').fadeOut(250);
        }
      }, 200);

      $(window).on('resize', function() {
        legendHeight = $('#rev-renderer-toggle').find('.apexcharts-legend').innerHeight();

        $(document).find('.chart_display_container').css('padding-bottom', legendHeight);
        $(document).find('.chart_display_container .apexcharts-legend').css('inset', 'auto 0px -' + legendHeight + 'px');

        setTimeout(function() {
          if (data.chartType === 'revToggled') {
            setTimeout(function() {
              $(document).find('.chart_display_container .apexcharts-legend').css('inset', 'auto 0px -' + legendHeight + 'px');
            }, 500);
          }
        }, 200);
      });
    });

  }

  legendFormatter (seriesName, opts) {
    var money = '$' + opts.w.globals.series[opts.seriesIndex].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return [seriesName, ' - ', money];
  }

  moneyFormatter (value) { //so this is how yo include a function that can't parse properly within the json files in /storage... name the function there and define it here
    if (value) {
      return '$' + value.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

  }

  pieFormatFormatter (val, opts) {
    return opts.w.globals.series[opts.seriesIndex].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  pieIncludeTitle (val, opts) {
    //        return "$" + opts.w.globals.series[opts.seriesIndex].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '\n' + opts.w.globals.labels[opts.seriesIndex];
    return opts.w.globals.labels[opts.seriesIndex];
  }

  pieMoneyFormatter (val, opts) {
    return '$' + opts.w.globals.series[opts.seriesIndex].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  //    pieRemoveMoneyOnLabel(val){
  //        return "$" + val.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //    }
  pieUpdateTitle (seriesName) {
    return seriesName + ': ';
  }
};

window.sflow = window.sflow || {};
window.sflow.chart = new Chart();